export const MIN_CREDIT_LIMIT = 10;
export const MAX_CREDIT_LIMIT = 250;
